import axios from "axios";
import { log } from "@/composables/useLog";
import { BASE_URL } from "@/composables/url_config";

export const getNotifications = async (token, page = 1, perPage = 20, unreadOnly = false) => {
  log("getNotifications called");
  try {
    const response = await axios.get(
      `${BASE_URL}/home/getNotificationsApi`,
      {
        params: { page, per_page: perPage, unread_only: unreadOnly },
        headers: { Authorization: `Bearer ${token}` }
      }
    );
    log("getNotifications response:");
    log(response.data);
    return response.data;
  } catch (error) {
    log("getNotifications error:");
    log(error);
    return { error: true, message: error.message };
  }
};

export const markNotificationRead = async (token, notificationId) => {
  log("markNotificationRead called for id: " + notificationId);
  try {
    const response = await axios.post(
      `${BASE_URL}/home/markNotificationReadApi`,
      { notification_id: notificationId },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    log("markNotificationRead error:");
    log(error);
    return { error: true, message: error.message };
  }
};

export const markAllNotificationsRead = async (token) => {
  log("markAllNotificationsRead called");
  try {
    const response = await axios.post(
      `${BASE_URL}/home/markAllNotificationsReadApi`,
      {},
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    log("markAllNotificationsRead error:");
    log(error);
    return { error: true, message: error.message };
  }
};

// Bulk MSISDN Purchase APIs
export const getBulkMsisdnPurchaseOptions = async (token, msisdnIds) => {
  log("getBulkMsisdnPurchaseOptions called for " + msisdnIds.length + " MSISDNs");
  try {
    const response = await axios.post(
      `${BASE_URL}/home/getBulkMsisdnPurchaseOptionsApi`,
      { msisdn_ids: msisdnIds },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    log("getBulkMsisdnPurchaseOptions response:");
    log(response.data);
    return response.data;
  } catch (error) {
    log("getBulkMsisdnPurchaseOptions error:");
    log(error);
    return { error: true, message: error.message };
  }
};

export const bulkPurchaseMsisdns = async (token, data) => {
  log("bulkPurchaseMsisdns called");
  log(data);
  try {
    const response = await axios.post(
      `${BASE_URL}/home/bulkPurchaseMsisdnsApi`,
      data,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    log("bulkPurchaseMsisdns response:");
    log(response.data);
    return response.data;
  } catch (error) {
    log("bulkPurchaseMsisdns error:");
    log(error);
    return { error: true, message: error.message };
  }
};
